import { z } from 'zod';
export const zUserMessageSchema = z.object({
    __typename: z.literal('ChatMessage'),
    id: z.guid(),
    content: z.string().nullable(),
    data: z.object({
        workflowId: z.guid(),
        type: z.literal('document-workflow'),
    }),
});
